var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReactinline = function SvgReactinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#react_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 0.945,
    d: "M15.527 8c0 .704-.65 1.497-2.066 2.14-1.373.625-3.303 1.023-5.461 1.023s-4.088-.398-5.461-1.022C1.123 9.497.473 8.704.473 8c0-.705.65-1.498 2.066-2.141C3.912 5.234 5.842 4.836 8 4.836s4.088.398 5.461 1.023c1.416.643 2.066 1.436 2.066 2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 0.945,
    d: "M12.025 14.742c-.221.127-.545.16-1.006.011s-1.005-.465-1.6-.948C8.233 12.84 6.93 11.278 5.812 9.34c-1.12-1.937-1.82-3.847-2.063-5.356-.12-.756-.122-1.386-.02-1.86.1-.473.29-.737.511-.865.221-.127.545-.16 1.006-.011s1.005.465 1.6.948c1.186.964 2.489 2.527 3.608 4.465 1.118 1.937 1.82 3.847 2.062 5.356.12.756.122 1.386.021 1.86-.101.473-.292.737-.512.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61DAFB",
    strokeWidth: 0.945,
    d: "M4.241 14.742c-.22-.128-.41-.392-.512-.866-.101-.473-.1-1.103.021-1.86.242-1.508.944-3.418 2.063-5.356C6.93 4.722 8.234 3.16 9.42 2.196c.595-.483 1.14-.8 1.6-.948.46-.15.785-.117 1.005.01.221.128.412.392.513.866.101.473.1 1.103-.021 1.86-.242 1.509-.944 3.418-2.063 5.356-1.118 1.938-2.421 3.5-3.607 4.464-.595.483-1.14.8-1.6.949s-.785.116-1.006-.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61DAFB",
    d: "M8.072 9.89a1.818 1.818 0 1 0 0-3.636 1.818 1.818 0 0 0 0 3.636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "react_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgReactinline;